





























































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Form } from 'element-ui'

// 1: 域账号, 2: 兔兔账号
type accountType = 1 | 2
@Component({
  name: 'FindPassword'
})
export default class extends Vue {
  // api data
  passwordForm1 = {
    account: '',
    password: '',
    rePassword: ''
  }
  passwordForm2 = {
    account: '',
    password: '',
    rePassword: ''
  }
  // template data
  accountType: accountType = 1
  // 添加自定义验证逻辑
  validateAccount = (rule: any, value: string, cb: Function) => {
    if (value.length === 0) {
      cb(new Error('账号不能为空'))
    } else {
      cb()
    }
  }
  validatePassword = (rule: any, value: string, cb: Function) => {
    if (value.length === 0) {
      cb(new Error('密码不能为空'))
    } else {
      cb()
    }
  }
  passwordRules1 = {
    account: [{ validator: this.validateAccount, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }
  passwordRules2 = {
    account: [{ validator: this.validateAccount, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }

  created() {
    console.log(this.$route.query)
  }

  // methods
  async lpadLogin() {
    // let res: any = await login1(this.passwordForm1)
    // if (res && res.status.code === 0) {
    // }
  }
  async tutuLogin() {
    // let res: any = await login2(this.passwordForm2)
    // if (res && res.status.code === 0) {
    // }
  }
  handleSwitch(type: accountType) {
    this.accountType = type
  }
  goToLogin() {
    this.$router.push('/login')
  }
  handleConfirm(type: accountType) {
    if (type === 1) {
      (this.$refs['passwordForm1'] as Form).validate(valid => {
        if (valid) {
          this.lpadLogin()
        } else {
          this['$message'].error('请填写完整的账户和密码!')
          return false
        }
      })
    } else {
      (this.$refs['passwordForm2'] as Form).validate(valid => {
        if (valid) {
          this.tutuLogin()
        } else {
          this['$message'].error('请填写完整的账户和密码!')
          return false
        }
      })
    }
  }
}
